const ANIMATION_SELECTOR: string = ".animated";
var inViewport = require('in-view');


export class AnimationUI {

  public constructor(private $base: HTMLElement) {
  }


  public isInViewport(onEnter: () => void) {
    if (inViewport.is(this.$base)) {
      onEnter();
    }
  }

  public isInFirstScreen(callback) {
    if (this.$base.classList.contains('animation--start')) {
      callback();
    }
  }

  public submitAnimation() {
    this.$base.classList.add('go');
  }
}

export function createAnimationUI() {
  const $base = document.querySelectorAll(ANIMATION_SELECTOR);
  let uiInstances: AnimationUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new AnimationUI(element));
  }

  return uiInstances;
}
